function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import Avatar from 'components/Avatar';
import Widget from 'components/Widget';
import * as constants from '../../../../constants';
import messages from '../../../../messages';
import styles from '../../Results.pcss';
import PrintablePatient from './PrintablePatient';
const PrintableHeader = ({ patient, accountPatientProfile, activeClinicMembership, isPatientMode, startDate, endDate, days, kpis })=>{
    const clinic = get(activeClinicMembership, 'clinic');
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            !isPatientMode && clinic && /*#__PURE__*/ _jsx(Widget, {
                widgetId: constants.CLINIC_DETAILS_HEADER_WIDGET,
                isNoHeader: true,
                className: styles.printableClinicDetailsWrapper,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.printableClinicDetails,
                        children: [
                            /*#__PURE__*/ _jsx(Avatar, {
                                imgClassName: styles.printableClinicDetails__logo,
                                avatarImg: clinic.logo
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: cn('text--normal', styles.printableClinicDetails__info),
                                children: [
                                    clinic.name,
                                    /*#__PURE__*/ _jsx("br", {}),
                                    clinic.street,
                                    /*#__PURE__*/ _jsx("br", {}),
                                    clinic.zipCode,
                                    " ",
                                    clinic.city
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Widget, {
                widgetId: constants.PATIENT_DETAILS_HEADER_WIDGET,
                isNoHeader: true,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-4",
                            children: /*#__PURE__*/ _jsx(PrintablePatient, {
                                patient: patient,
                                accountPatientProfile: accountPatientProfile,
                                isPatientMode: isPatientMode
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-8 align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.printableHeaderFeatures,
                                    children: kpis
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.printableHeaderRow,
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: styles.printableHeaderRow__date,
                                        children: [
                                            /*#__PURE__*/ _jsxs("h3", {
                                                className: "text--h3",
                                                children: [
                                                    startDate && startDate.format('ll'),
                                                    " - ",
                                                    endDate && endDate.format('ll')
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("h4", {
                                                className: "text--h3",
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.presets.days), {
                                                        values: {
                                                            number: days
                                                        }
                                                    })),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default PrintableHeader;
